export const PLATFORMS_URL = {
  VOLUSION2: 'https://www.volusion.com',
};
